import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCompressArrowsAlt, faExpandArrowsAlt, faWifi, faVideo, faGlobe, faList, faSlash
} from '@fortawesome/free-solid-svg-icons'

library.add(faCompressArrowsAlt, faExpandArrowsAlt, faWifi, faVideo, faGlobe, faList, faSlash)
